<div class="menu-mobile-container">
    <button class="button-close" mat-icon-button color="primary" (click)="close()">
        <mat-icon fontSet="phr-iconset" class="phr-iconset-close icon"></mat-icon>
    </button>
    <!--<app-menu></app-menu>-->
    <app-dynamic [componentName]="menuComponentName" [componentData]=""></app-dynamic>
</div>